import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

/**
 * Avatar properties.
 */
export interface IAvatarProps extends TestingProps {
  src?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  rounded?: boolean;
  circle?: boolean;
  className?: string;
  text?: string;
  textClassName?: string;
}

const placeholder = 'https://via.placeholder.com/64';

const sizeMapper: { [index: string]: string } = {
  xs: 'avatar-xs',
  sm: 'avatar-sm',
  lg: 'avatar-lg',
  xl: 'avatar-xl',
  xxl: 'avatar-xxl',
};

export const Avatar: React.FC<IAvatarProps> = ({
  rounded = true,
  size = 'md',
  ...props
}: IAvatarProps) => {
  const [loaded, setLoaded] = React.useState<boolean>(false);

  const handleThumbnailLoaded = () => {
    setLoaded(true);
  };

  const handleThumbnailError = () => {
    setLoaded(false);
  };
  return (
    <div
      className={C(
        'avatar',
        size && sizeMapper[size],
        props.className,
        props.src && !loaded && 'd-none',
        props.className
      )}
      data-testid={props.testId}
    >
      {props.src ? (
        <img
          src={props.src}
          alt="avatar"
          className={C(
            'avatar-img',
            rounded && 'rounded',
            props.circle && 'rounded-circle'
          )}
          onLoad={handleThumbnailLoaded}
          onError={handleThumbnailError}
        />
      ) : (
        <span
          className={C(
            'avatar-title',
            rounded && 'rounded',
            props.circle && 'rounded-circle',
            props.textClassName
          )}
        >
          {props.text}
        </span>
      )}
    </div>
  );
};
